import { Component } from 'react';
import { Box, Button, Drawer, Stack, Tooltip, Typography } from '@mui/material'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import './RadRpts.css'
import { Colors } from '../../../Styles/Colors'
import { AmountsCard } from '../../../Components/CommonCards/CommonCards'
import { DataGrid } from '@mui/x-data-grid'
import CommonGridHeader from '../../../Components/Common Components/CommonComponents'
import { ImagePaths } from '../../../Utility/ImagePaths'
import { CurrencySymbol } from '../../../Utility/Constants'
import { DateTime } from 'luxon'
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import { AmountFormat } from '../../../Components/CommonFunctions/CommonFunctions'
import { localGetItem } from '../../../Utility/Services/CacheProviderService'

export default class RadCensus extends Component {
  constructor(props) {
    super(props)
    this.state = {
      censusReportData: [],
      totalTests: 0,
      censusAmount: 0,
      page: 0,
      pageSize: 10,
      loading: false,
      fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      dateIndex: 1,
      FilterOpen: false
    }
  }

  componentDidMount() {
    this.getCensusReportData()
  }

  getCensusReportData = () => {
    try {
      const baseUrl = (localGetItem('is_investigation_module') === "true" ? Serviceurls.NEW_INVESTIGATION_CENCUS_REPORT : Serviceurls.NEW_RAD_CENCUS_REPORT);
      RestAPIService.getAll(baseUrl + `?from_date=${this.state.fromDate}&to_date=${this.state.toDate}`)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              censusReportData: response.data.data,
              censusAmount: response.data.total_amount,
              totalTests: response.data.total_test
            })
          }
        }).catch((error) => {
          this.errorMessage(error?.response?.data?.message || error.message)
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getCencusReportPrint = () => {
    try {
      this.setState({ disableBtn: true })
      const baseUrl = (localGetItem('is_investigation_module') === "true" ? Serviceurls.NEW_INVESTIGATION_CENCUS_REPORT : Serviceurls.NEW_RAD_CENCUS_REPORT);
      RestAPIService.getAll(`${baseUrl}?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&export_type=pdf`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ disableBtn: false })
        }).catch((error) => {
          this.setState({ disableBtn: false })
          this.errorMessage(error?.response?.data?.message || error.message)
        })
    } catch (error) {
      this.setState({ disableBtn: false })
      this.errorMessage(error.message)
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  FilterDate = (from, to, index) => {
    this.setState({
      fromDate: from,
      toDate: to,
      dateIndex: index
    })
  }

  closeFilter = () => {
    this.setState({
      FilterOpen: false
    })
  }
  renderFilterScreen = () => {
    return (
      <Box component={"div"} className='eMed_rts_filter_container'>
        <Box component={"div"} className='eMed_filter_Top'>
          <Typography variant='h6' fontWeight={600}>{'Filter'}</Typography>
          <Button onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
          </Button>
        </Box>
        <Box className='eMed_rts_middle'>
          <Box className='eMed_date_filter'>
            <CommonDatePicker
              FromDate={this.state.fromDate}
              ToDate={this.state.toDate}
              DateIndex={this.state.dateIndex}
              SelectedDates={this.FilterDate.bind(this)}
              HideAllMenu={true} />
          </Box>
        </Box>
        <Stack spacing={2} direction="row" className='eMed_rts_btn' alignItems="center" justifyContent="center">
          <Button variant='outlined' size="small"
            onClick={() => {
              this.setState({
                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                dateIndex: 1,
              },
                () => this.getCensusReportData()
              )
            }}
            id="eMed_Config_btn">{"Clear"}</Button>
          <Button variant='contained' size="small"
            onClick={() => {
              this.getCensusReportData()
              this.setState({ FilterOpen: false })
            }}
            id="eMed_Config_btn">{"Search"}</Button>
        </Stack>
      </Box>
    )
  }

  render() {
    this.state.censusReportData?.forEach((element, index) => element.sno = index + 1)
    const column = [
      { field: 'sno', headerName: 'S.No', flex: 0.05 },
      {
        field: 'service_type', headerName: "Service Head", flex: 0.2,
        renderCell: (params) => (<Box component={'div'} emed_tid={'rad_rpts_ser_type_cen'}>{params?.row?.service_type ?
          params?.row?.service_type?.length > 20 ?
            <Tooltip placement='top' title={params?.row?.service_type}><Typography>{params?.row?.service_type?.slice(0, 20) + '...'}</Typography></Tooltip> :
            <Typography>{params?.row?.service_type}</Typography> : '-'}</Box>)
      },
      {
        field: 'service_name', headerName: 'Service Name', flex: 0.35,
        renderCell: (params) => (<Box component={'div'} emed_tid={'rad_rpts_ser_name_cen'}>{params?.row?.service_name ?
          params?.row?.service_name?.length > 25 ?
            <Tooltip placement='top' title={params?.row?.service_name}>
              <Typography>{params?.row?.service_name?.slice(0, 25) + '...'}</Typography>
            </Tooltip> :
            <Typography>{params?.row?.service_name}</Typography> : '-'}</Box>)
      },
      {
        field: 'amount', headerName: `Amount (${CurrencySymbol})`, flex: 0.2, type: "number",
        renderCell: (params) => (<Box component={'div'} emed_tid={'rad_rpts_amt_cen'}>{AmountFormat(params?.row?.amount || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)
      },
      {
        field: 'count', headerName: 'Count', flex: 0.2, type: "number",
        renderCell: (params) => (<Box component={'div'} emed_tid={'rad_rpts_count_cen'}>{params?.row?.count}</Box>)
      },
    ]
    return (
      <Box component={'div'}>
        <Box component={'div'} className='rad_Rpts_container' sx={{ backgroundColor: Colors.Background }}>
          <Box component={'div'} className='rad_rpts_header_card'>
            <Box component={'div'} className='rad_rpts_cards'>
              {AmountsCard("Total Tests", this.state.totalTests, true, "white", false, null, "rad_cen_totl_tst")}
              {AmountsCard("Amount", this.state.censusAmount, false, "white", false, null, 'rad_cen_amt')}
            </Box>
            <Box component={'div'} className='rad_rpts_btns'>
              <Tooltip placement='top' title={'Filter'} arrow onClick={() => this.setState({ FilterOpen: true })}>
                <Button className='Common_Btn_Min_Width' sx={{ height: '2vw' }} emed_tid='rad_rpts_flt_cen'>
                  <Box component={'img'} src={ImagePaths.Filter.default} height={'2vw'} width={'2vw'} />
                </Button>
              </Tooltip>
              <Tooltip placement='top' title={'Print'} arrow>
                <Button className='Common_Btn_Min_Width' sx={{ height: '2vw' }} emed_tid='rad_rpts_prt_cen'
                  disabled={this.state.disableBtn}
                  onClick={() => this.getCencusReportPrint()}
                >
                  <Box component={'img'} src={ImagePaths.LabPrintIcon.default} height={'2vw'} width={'2vw'} />
                </Button>
              </Tooltip>
            </Box>
          </Box>
          <Box component={'div'} className='rad_rpts_content_card'>
            <DataGrid
              sx={{ backgroundColor: Colors.white }}
              columns={column}
              rows={this.state.censusReportData}
              getRowId={(row) => row['sno']}
              localeText={{
                toolbarColumns: "",
                toolbarDensity: "",
                toolbarExport: "",
                toolbarFilters: "",
                toolbarExportPrint: ""
              }}
              components={{
                Toolbar: CommonGridHeader.CommonToolBar,
                NoRowsOverlay: () => (
                  <Box className='eMed_conf_nodata'>
                    {'No Records To Be Shown'}
                  </Box>
                )
              }}
              pageSizeOptions={[10, 20, 30]}
              pagination
              paginationMode="client"
              paginationModel={{
                page: this.state.page,
                pageSize: this.state.pageSize
              }}
              onPaginationModelChange={(model) => {
                this.setState({
                  page: model.page,
                  pageSize: model.pageSize
                })
              }}
              headerHeight={40}
              disableRowSelectionOnClick
              loading={this.state.loading}
            />
          </Box>
        </Box>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        <Drawer
          anchor={'right'}
          open={this.state.FilterOpen}
          ModalProps={{ onBackdropClick: this.closeFilter }}
        >
          {this.renderFilterScreen()}
        </Drawer>
      </Box>
    )
  }
}